<template>
  <div class="user-vip">
    <NavHeaderBar title="VIP会员" leftArrow rightArrow />
    <div class="uv-img">
      <img :src="imgurl" />
    </div>
    <div class="uv-text">VIP会员暂时通过人工审核</div>
    <div class="uv-textone">请与管理处联系</div>
    <div class="uv-fx"></div>
    <div class="uv-footer">
      <div class="uvf-text">联系电话：135-2249-1212</div>
      <div class="uvf-textone">联系人: 王兰平 (主任）</div>
    </div>
  </div>
</template>

<script>
// import apis from "@/config/apis";
export default {
  name: "MyVip",
  data: () => ({
    imgurl: require("@/assets/img/df-5.png"),
    arrows: true,
    name: ""
  }),
  props: {},
  created() {
    this.name = this.$route.query.name;
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss">
.user-vip {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  .uv-img {
    width: 250px;
    height: 250px;
    img {
      width: 100%;
      height: 100%;
      background-size: 100%;
    }
  }
  .uv-text {
    margin-top: 20px;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
    color: #2271e9;
  }
  .uv-textone {
    font-weight: 400;
    line-height: 16.5px;
    color: #2271e9;
    margin: 6px 0;
  }
  .uv-fx {
    width: 22px;
    height: 0.5px;
    background: #2271e9;
  }
  .uvf-text {
    margin-top: 20px;
    font-size: 13px;
    font-weight: 400;
    line-height: 18.5px;
    color: #333333;
  }
  .uvf-textone {
    margin-top: 7px;
    font-size: 13px;
    font-weight: 400;
    line-height: 18.5px;
    color: #333333;
  }
}
</style>
